import { get, includes } from 'lodash';
import Role from '../../Constants/roles.ts';

export default function isCompliance(user) {
  return includes([Role.COMPLIANCE, Role.ADMIN], get(user, 'role'));
}
